<template>
  <div class="mt-10">
    <h3>
      {{ $t('faqs.heading') }}
    </h3>
    <div class="faqs px-6 py-2 mt-6 rounded-md">
      <DefaultAccordion :items="items" />
    </div>
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()
const faqsStore = useFaqsStore()
const faqLimit = Number(config.public?.faqListLimit || 100)

const items = computed(() => {
  const faqs = faqsStore.faqs
  return faqs.map((faq) => {
    return {
      label: faq.question,
      content: faq.answer,
    }
  })
})

// fetch data
try {
  faqsStore.setLimit(faqLimit)
  await faqsStore.fetchFaqs()
} catch (e) {
  console.error('ERROR', e)
}

</script>